import type { Dispatch } from "@reduxjs/toolkit";

import { GetEngageStoreBatchesQuery, GetInventoryItemsQuery } from "~/gql/queries/inventory.generated";
import { GetInventoryTransactionsQuery } from "~/gql/queries/inventoryTransactions.generated";
import mapInventoryTransactionsToCache from "~/helpers/offline/mapInventoryTransactionsToCache";
import { setCachedTransactions } from "~/store/availabilitySlice";

interface OnQueryStartedLifecycle {
	dispatch: Dispatch;
	queryFulfilled: Promise<{ data: GetInventoryTransactionsQuery }>;
}

export const inventoryEndpoints = {
	GetInventoryItemStockSummary: {
		providesTags: (_result: unknown, _error: unknown, arg: { itemId: string }) => [
			{ type: "InventoryStockSummary" as const, id: arg.itemId }
		]
	},
	GetEngageStoreBatches: {
		providesTags: ["InventoryItems", "CycleCountHistory"] as AddTagTypes,
		transformResponse: (res: GetEngageStoreBatchesQuery) => res
	},
	GetInventoryItems: {
		providesTags: ["InventoryItems"] as AddTagTypes,
		transformResponse: (res: GetInventoryItemsQuery) => {
			return res;
		}
	},
	GetInventoryTransactions: {
		async onQueryStarted(_arg: unknown, { dispatch, queryFulfilled }: OnQueryStartedLifecycle) {
			try {
				const { data } = await queryFulfilled;
				const nodes = data.inventoryTransactions?.nodes ?? [];
				if (nodes.length === 0) return;
				dispatch(setCachedTransactions(mapInventoryTransactionsToCache(nodes)));
			} catch {}
		},
		providesTags: ["InventoryTransactions"] as AddTagTypes,
		transformResponse: (res: GetInventoryTransactionsQuery) => res
	},
	GetInventoryTransactionsForKey: {
		providesTags: ["InventoryTransactions"] as AddTagTypes
	}
};
